import template from './group_list.html';

angular
  .module('bb.users')

  .config([
    '$routeProvider',
    function ($routeProvider) {
      $routeProvider.when('/users/groups', {
        template,
        controller: 'GroupListCtrl',
      });
    },
  ]);
